import cn from 'classnames';
import { useColor } from '../useColor';
import styles from './styles.module.css';
const ELEMENT_MAP = {
    header: 'h1',
    title1: 'h2',
    title2: 'h3',
    title3: 'h4',
    title4: 'h5',
    body1: 'h6',
    body2: 'span',
    caption1: 'span',
    caption2: 'span',
};
export function useTypography({ variant, thickness = 'regular', group = 'tight', color, className, }) {
    const colorClass = useColor(color);
    return {
        DefaultComponent: ELEMENT_MAP[variant],
        className: cn(styles.typography, styles[variant], styles[thickness], styles[group], colorClass, className),
    };
}
